import {useEffect} from 'react';

import {isEmpty, isNil} from 'ramda';

import {omneticApi} from '@dms/api/base';

import {createNotificationSubscription} from './subscription/createNotificationSubscription';
import {SubscribeToNotificationsApiArg} from './types';

export const appSyncApi = omneticApi.injectEndpoints({
  endpoints: (build) => ({
    subscribeToNotifications: build.query<SubscribeToNotificationsApiArg[], void>({
      queryFn: () => ({data: []}),
      keepUnusedDataFor: 0,
      async onCacheEntryAdded(_args, {cacheEntryRemoved, getState, dispatch, updateCachedData}) {
        const subscription = createNotificationSubscription({getState, dispatch, updateCachedData});

        subscription.start();
        await cacheEntryRemoved;
        subscription.stop();
      },
    }),
  }),
});

export const useSubscribeToNotificationsQuery = (
  onData: (notification: SubscribeToNotificationsApiArg) => void
) => {
  const {data: latestData} = appSyncApi.useSubscribeToNotificationsQuery();

  useEffect(
    function forwardLatestDataItem() {
      if (isNil(latestData) || isEmpty(latestData)) {
        return;
      }

      onData(latestData[latestData.length - 1]);
    },
    [latestData] // eslint-disable-line react/exhaustive-deps -- Muted pre-existing violation
  );

  return [latestData];
};
